var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77747 0.994385V19.0071C9.77747 19.0071 16.5976 16.6825 17.5877 10.957L17.8952 4.40137C17.8952 4.40137 18.1842 2.85777 16.3331 2.35349C14.4821 1.84921 12.5141 1.24653 9.78362 1.00053L9.77747 0.994385Z",
    fill: "#718AF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6397 2.37033C10.7631 1.85752 8.78532 1.85752 6.90878 2.37033L3.4834 3.30508C3.48327 3.30512 3.48353 3.30504 3.4834 3.30508C2.99287 3.43935 2.65245 3.88349 2.65245 4.39521V8.37412C2.65245 12.8039 5.55247 16.696 9.77422 17.9732C13.996 16.696 16.896 12.8039 16.896 8.37412V4.39521C16.896 3.88793 16.5543 3.43901 16.0654 3.30519C16.0653 3.30515 16.0656 3.30522 16.0654 3.30519L12.6397 2.37033ZM9.44975 19.9467C9.55086 19.9813 9.65906 20 9.77115 20H9.7773C9.88939 20 9.99758 19.9813 10.0987 19.9467C15.2921 18.497 18.8818 13.7676 18.8818 8.37412V4.39521C18.8818 2.99619 17.9444 1.76017 16.5886 1.38958L13.1631 0.454795C13.1632 0.454826 13.163 0.454764 13.1631 0.454795C10.9441 -0.151536 8.60467 -0.151629 6.38566 0.454702L2.96023 1.38947C1.60604 1.75962 0.666687 2.98833 0.666687 4.39521V8.37412C0.666687 13.7676 4.25635 18.497 9.44975 19.9467Z",
    fill: "#16002C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9233 6.18381C14.311 6.57156 14.311 7.20022 13.9233 7.58796L9.85212 11.6591C9.66579 11.8455 9.41303 11.9501 9.14951 11.9499C8.88599 11.9498 8.63334 11.8449 8.44721 11.6584L5.62446 8.82946C5.23713 8.44129 5.23782 7.81263 5.62598 7.42531C6.01415 7.03799 6.64281 7.03867 7.03013 7.42684L9.15081 9.55214L12.5191 6.18381C12.9069 5.79607 13.5355 5.79607 13.9233 6.18381Z",
    fill: "#16002C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShield);
export default __webpack_public_path__ + "static/media/ic-shield.863e9bf04217e349be48eb7344a955f0.svg";
export { ForwardRef as ReactComponent };